import { getAppDescriptor as getAppDescriptorAmbassador } from '@wix/ambassador-blocks-v1-app-descriptor/http';
import { parseBaseUrlsData } from '../../utils';
const resolveAppDescriptorRequestParams = (appData, appRevisionOverride) => {
    const baseUrls = appData.appFields.platform?.baseUrls;
    const siteHeaderUrl = baseUrls?.siteHeaderUrl ||
        appData.appFields.platform?.studio?.siteHeaderUrl;
    const revisionString = appRevisionOverride ??
        (baseUrls ? parseBaseUrlsData(baseUrls).revision : undefined);
    const parsedRevision = revisionString != null ? parseInt(revisionString, 10) : NaN;
    const revision = Number.isFinite(parsedRevision) ? parsedRevision : undefined;
    return {
        appDefinitionId: appData.appDefinitionId,
        siteHeaderUrl,
        revision,
    };
};
export class AppDescriptorApiFactory {
    async createAppDescriptorApi(options) {
        return {
            getAppDescriptor: getAppDescriptorPlatformized(options.essentials),
        };
    }
}
const getAppDescriptorPlatformized = (essentials) => async ({ appData, appRevisionOverride, }) => {
    const httpClient = essentials.httpClient;
    if (!httpClient) {
        throw new Error('httpClient is required in essentials to fetch app descriptor');
    }
    const errorHandler = essentials.errorHandler ?? {
        withErrorHandler: (fn) => {
            return fn();
        },
    };
    const { appDefinitionId, siteHeaderUrl, revision } = resolveAppDescriptorRequestParams(appData, appRevisionOverride);
    const response = await errorHandler.withErrorHandler(() => httpClient.request(getAppDescriptorAmbassador({
        appDescriptorId: appDefinitionId,
        siteHeaderUrl,
        revision,
    })), { errorCodesMap: {} });
    const { id, ...appDescriptor } = response.data.appDescriptor ?? {};
    return appDescriptor;
};
//# sourceMappingURL=AppDescriptorApiFactory.js.map